import assignOrganization from './assignOrganization';
import assignPayAction from './assignPayAction';
import assignPriceSpecification from './assignPriceSpecification';
import type Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import type Invoice from '../../schema/Invoice';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';

/**
 * parse data for Invoice Entity
 */
export default function setInvoiceEntityData(
    entity: Entity,
    invoiceEntity: any,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
): Invoice {
    if (entity && invoiceEntity && isInvoiceValid(invoiceEntity, entity, isValidDate)) {
        // assign the invoice data
        let newInvoiceEntity: Invoice = {
            ...entity,
            ...{
                entityName: EntityTypeNames.Invoice,
                entityType: EntityType.Invoice,
                accountId: invoiceEntity.accountId,
                accountIdEndsIn: invoiceEntity['accountId/ending'],
                billingPeriod: invoiceEntity.billingPeriod,
                scheduledPaymentDate: invoiceEntity.scheduledPaymentDate,
                broker: assignOrganization({}, invoiceEntity.broker),
                category: invoiceEntity.category,
                customer: invoiceEntity.customer,
                provider: assignOrganization({}, invoiceEntity.provider),
                minimumPaymentDue: assignPriceSpecification({}, invoiceEntity.minimumPaymentDue),
                totalPaymentDue: assignPriceSpecification({}, invoiceEntity.totalPaymentDue),
                paymentDueDate: invoiceEntity.paymentDueDate,
                potentialAction: assignPayAction({}, invoiceEntity.potentialAction),
                paymentStatus: invoiceEntity.paymentStatus,
            },
        };

        return newInvoiceEntity;
    }
    return null;
}

// Check if all the required fields are present in the invoice
export function isInvoiceValid(
    invoiceEntity: any,
    entity: Entity,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
) {
    const isDateValidUsingCallback: boolean = isValidDate
        ? isValidDate(invoiceEntity.scheduledPaymentDate, false /* isUtcTime*/, entity) ||
          isValidDate(invoiceEntity.paymentDueDate, false /* isUtcTime*/, entity)
        : true;

    if (
        invoiceEntity &&
        (invoiceEntity.accountId || invoiceEntity.accountIdEndsIn) &&
        invoiceEntity.provider &&
        invoiceEntity.provider.name &&
        (invoiceEntity.scheduledPaymentDate || invoiceEntity.paymentDueDate) &&
        isDateValidUsingCallback
    ) {
        return true;
    }
    return false;
}
